/**
 * @generated SignedSource<<3d3a6021310ed58a32d928cb8ffc0cc0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Site_site$data = {
  readonly page: {
    readonly __typename: string;
    readonly header: {
      readonly " $fragmentSpreads": FragmentRefs<"PageHeader_pageHeader">;
    } | null | undefined;
    readonly id: string;
    readonly pageTitle: string | null | undefined;
    readonly translations: ReadonlyArray<{
      readonly language: string | null | undefined;
      readonly url: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"PageHeader_translations">;
    }> | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ArchivePage_page" | "ContactPage_page" | "ContentPage_page" | "CutOffListPage_page" | "DeniedPage_page" | "FrontPage_page" | "FundsDetailsPage_page" | "FundsListPage_page" | "InfoServicePage_page" | "PublicationsPage_page" | "SearchPage_page" | "SectionPage_page" | "SimplePage_page" | "VisitorInfoPage_page">;
  } | null | undefined;
  readonly siteInfo: {
    readonly " $fragmentSpreads": FragmentRefs<"PageFooter_siteFooter" | "PageHeader_siteInfo">;
  } | null | undefined;
  readonly specialPage: {
    readonly __typename: string;
    readonly " $fragmentSpreads": FragmentRefs<"VisitorInfoPage_page">;
  } | null | undefined;
  readonly userCountry: string | null | undefined;
  readonly " $fragmentType": "Site_site";
};
export type Site_site$key = {
  readonly " $data"?: Site_site$data;
  readonly " $fragmentSpreads": FragmentRefs<"Site_site">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "path",
  "variableName": "path"
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "salesAdmission",
    "variableName": "salesAdmission"
  }
],
v3 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "VisitorInfoPage_page"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "language"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "path"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "salesAdmission"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchString"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "specialPageId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "visitorInfo"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Site_site",
  "selections": [
    {
      "alias": null,
      "args": [
        (v0/*: any*/),
        {
          "kind": "Variable",
          "name": "visitorInfo",
          "variableName": "visitorInfo"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "page",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageHeader",
          "kind": "LinkedField",
          "name": "header",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PageHeader_pageHeader"
            }
          ],
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "args": (v2/*: any*/),
          "kind": "FragmentSpread",
          "name": "FundsDetailsPage_page"
        },
        {
          "args": (v2/*: any*/),
          "kind": "FragmentSpread",
          "name": "FundsListPage_page"
        },
        {
          "args": (v2/*: any*/),
          "kind": "FragmentSpread",
          "name": "InfoServicePage_page"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SimplePage_page"
        },
        {
          "args": (v2/*: any*/),
          "kind": "FragmentSpread",
          "name": "ArchivePage_page"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CutOffListPage_page"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FrontPage_page"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContentPage_page"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SectionPage_page"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContactPage_page"
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "searchString",
              "variableName": "searchString"
            }
          ],
          "kind": "FragmentSpread",
          "name": "SearchPage_page"
        },
        (v3/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PublicationsPage_page"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DeniedPage_page"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Translation",
          "kind": "LinkedField",
          "name": "translations",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "language",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PageHeader_translations"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userCountry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v0/*: any*/)
      ],
      "concreteType": "SiteInfo",
      "kind": "LinkedField",
      "name": "siteInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PageHeader_siteInfo"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PageFooter_siteFooter"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "language",
          "variableName": "language"
        },
        {
          "kind": "Variable",
          "name": "pageId",
          "variableName": "specialPageId"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "specialPage",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Site",
  "abstractKey": null
};
})();

(node as any).hash = "da56035283262f47d77da84e2d9397fc";

export default node;
